import './toscana/style';
import FormStructure from './toscana/form_structure';

export default FormStructure;